/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created: ${i?.date}`)
};

const zh_hans1_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`创建时间：${i?.date}`)
};

const zh_hant1_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`建立時間：${i?.date}`)
};

const fr_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Créée : ${i?.date}`)
};

const de_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt: ${i?.date}`)
};

const ja_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作成日: ${i?.date}`)
};

const ko_settings_created_at = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`생성됨: ${i?.date}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_created_at = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_created_at(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_created_at", locale)
	if (locale === "en") return en_settings_created_at(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_created_at(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_created_at(inputs)
	if (locale === "fr") return fr_settings_created_at(inputs)
	if (locale === "de") return de_settings_created_at(inputs)
	if (locale === "ja") return ja_settings_created_at(inputs)
	return ko_settings_created_at(inputs)
};